import { createReducer } from "redux-act";
import createAction from "../utils/createMetaAction";
export const addBps = createAction("addBps");
export default createReducer({}, "");
